// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fd-0";
export var fileCarousel = "_fd-2";
export var removeFileButton = "_fd-1";